var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnorderedList = function SvgUnorderedList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0.75H1.25C0.96875 0.75 0.75 1 0.75 1.25V2.75C0.75 3.03125 0.96875 3.25 1.25 3.25H2.75C3 3.25 3.25 3.03125 3.25 2.75V1.25C3.25 1 3 0.75 2.75 0.75ZM2.75 5.75H1.25C0.96875 5.75 0.75 6 0.75 6.25V7.75C0.75 8.03125 0.96875 8.25 1.25 8.25H2.75C3 8.25 3.25 8.03125 3.25 7.75V6.25C3.25 6 3 5.75 2.75 5.75ZM2.75 10.75H1.25C0.96875 10.75 0.75 11 0.75 11.25V12.75C0.75 13.0312 0.96875 13.25 1.25 13.25H2.75C3 13.25 3.25 13.0312 3.25 12.75V11.25C3.25 11 3 10.75 2.75 10.75ZM15.75 11.5H5.25C5.09375 11.5 5 11.625 5 11.75V12.25C5 12.4062 5.09375 12.5 5.25 12.5H15.75C15.875 12.5 16 12.4062 16 12.25V11.75C16 11.625 15.875 11.5 15.75 11.5ZM15.75 1.5H5.25C5.09375 1.5 5 1.625 5 1.75V2.25C5 2.40625 5.09375 2.5 5.25 2.5H15.75C15.875 2.5 16 2.40625 16 2.25V1.75C16 1.625 15.875 1.5 15.75 1.5ZM15.75 6.5H5.25C5.09375 6.5 5 6.625 5 6.75V7.25C5 7.40625 5.09375 7.5 5.25 7.5H15.75C15.875 7.5 16 7.40625 16 7.25V6.75C16 6.625 15.875 6.5 15.75 6.5Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnorderedList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unordered-list.daa9f079.svg";
export { ForwardRef as ReactComponent };